interface QueryParams {
  redirect?: string
}

export const urlToRedirectWhenVisitingAccessAlreadyLogged = (query: QueryParams): string => {
  const currentRedirectTo: string = query?.redirect ? query.redirect.split('?')[0] : ''
  return `/dashboard/overview${currentRedirectTo ? `?from=${currentRedirectTo}` : ''}`
}